export const frecuencia_options = [
  { value: 'diario', label: 'Diario' },
  { value: 'semanal', label: 'Semanal' },
  { value: 'mensual', label: 'Mensual' },
  { value: 'solo una vez', label: 'Solo una vez' }
];
